import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../../feature'
import type { Manager } from '../manager'

export const deleteNodeFromCytoscape = store.effects.create(
  (feature: Feature, manager: Manager) =>
    feature.actions.deleteNode.success.observe().pipe(
      rxjs.map(
        ({
          data: {
            response: { chartId, id },
          },
        }) => {
          const cy = manager.getInstance({ chartId })
          if (!id || !cy) {
            return
          }
          const nodeToRemove = cy.getElementById(id)
          nodeToRemove.connectedEdges().remove()
          nodeToRemove.remove()
          manager.resetLayout({ chartId })
        },
      ),
      rxjs.ignoreElements(),
    ),
)
